import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useCurrencyFormatter } from 'hooks/useCurrencyFormatter';
import { printPriceTitle } from 'lib/util/util';
import { Price } from 'lib/util/productShape';

interface Props {
  prices: Price[];
}

export const PricePanel = ({ prices }: Props) => {
  const { t } = useTranslation();

  const currencyFormatter = useCurrencyFormatter();

  return (
    <ul className="widget-calendar__price">
      {prices.map((price, idx) => (
        <li key={idx} className="widget-calendar__price__item">
          <div className="widget-calendar__price__item__ttl">{printPriceTitle(price, t)}</div>
          <div className="widget-calendar__price__item__money">
            <p className="normal">{currencyFormatter.format(price.amount)}</p>
          </div>
        </li>
      ))}
    </ul>
  );
};
